import { render } from "./ModalSendInvoicePicker.vue?vue&type=template&id=ff8d1c60&scoped=true&ts=true"
import script from "./ModalSendInvoicePicker.vue?vue&type=script&lang=ts"
export * from "./ModalSendInvoicePicker.vue?vue&type=script&lang=ts"

import "./ModalSendInvoicePicker.vue?vue&type=style&index=0&id=ff8d1c60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8d1c60"]])

export default __exports__